var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampainHistoryMsgIconHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AdobeStock_532661912",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.145,
    height: 12.242,
    viewBox: "0 0 12.145 12.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M41.266,156v3.879h-2.44A1.854,1.854,0,0,1,37,158v-.122A1.855,1.855,0,0,1,38.825,156Z",
    transform: "translate(-37 -153.153)",
    fill: "#0052cc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M208.674,52.359v8.6a.469.469,0,0,1-.2.388.486.486,0,0,1-.416.08l-5.266-2.817v-3.9l5.272-2.8a.444.444,0,0,1,.405.057A.462.462,0,0,1,208.674,52.359Z",
    transform: "translate(-198.193 -51.889)",
    fill: "#0052cc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M428.331,168.587A1.565,1.565,0,0,1,427,170.173V167A1.564,1.564,0,0,1,428.331,168.587Z",
    transform: "translate(-416.186 -164.052)",
    fill: "#0052cc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M110.587,303.93v3.956a.889.889,0,1,1-1.762,0V303.93Z",
    transform: "translate(-106.833 -296.654)",
    fill: "#0052cc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampainHistoryMsgIconHover);
export default __webpack_public_path__ + "static/media/campain-history-msg-icon-hover.11000e577777148828af878635538d33.svg";
export { ForwardRef as ReactComponent };